import { Text, VStack } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';

import { ColumnComponentProps } from '../../../types/activity-column-types';
import {
  formatCurrency,
  FulfillmentStage,
  getActivityItemDisplay,
  getCheckoutSubtotal,
  hasSubtotalValue,
  isActivityDetailFulfillmentStageVisible,
  resolveActivityCheckoutDisplaySubtotal,
  shouldShowCheckoutSubtotalPlaceholder,
  shouldShowFulfillmentSubtotalDiscrepancy,
} from '../../../utils/activity-formatters';
import { ActivityDetailDiscrepancyDot } from '../../activity-detail/activity-detail-discrepancy-dot';
import { ActivityDetailStagePlaceholder } from '../../activity-detail/activity-detail-stage-qty-cell';

type FulfillmentSubtotalKey =
  | 'processed_subtotal'
  | 'delivered_subtotal'
  | 'received_subtotal';

type Props = ColumnComponentProps<
  BackofficeActivitiesOrderItem,
  number | null | undefined
> & {
  mode: 'checkout' | FulfillmentSubtotalKey;
  orderStatus?: string;
};

const FULFILLMENT_SUBTOTAL_STAGE: Record<
  FulfillmentSubtotalKey,
  FulfillmentStage
> = {
  processed_subtotal: 'processed',
  delivered_subtotal: 'delivered',
  received_subtotal: 'received',
};

export function StageSubtotalColumn({ info, mode, orderStatus }: Props) {
  const item = info.row.original;
  const checkoutSub = getCheckoutSubtotal(item);
  const display = getActivityItemDisplay(item);

  if (mode === 'checkout') {
    if (!display.showPriceSection) {
      return null;
    }

    if (
      shouldShowCheckoutSubtotalPlaceholder(
        orderStatus,
        item.checkout_subtotal,
        item.original_subtotal
      )
    ) {
      return <ActivityDetailStagePlaceholder />;
    }

    const checkoutSubtotalValue = resolveActivityCheckoutDisplaySubtotal(item);

    if (checkoutSubtotalValue == null) {
      return (
        <Text
          fontSize="sm"
          fontWeight="400"
          color="#373F41"
          textAlign="center"
          w="full"
        >
          -
        </Text>
      );
    }

    return (
      <VStack align="center" spacing={0} w="full">
        <Text fontSize="sm" fontWeight="400" color="#373F41" textAlign="center">
          {formatCurrency(checkoutSubtotalValue)}
        </Text>
      </VStack>
    );
  }

  const groupSub = item[mode];

  if (
    !isActivityDetailFulfillmentStageVisible(
      orderStatus,
      FULFILLMENT_SUBTOTAL_STAGE[mode],
      item
    )
  ) {
    return <ActivityDetailStagePlaceholder />;
  }

  if (groupSub == null) {
    return (
      <Text fontSize="sm" fontWeight="400" color="#373F41" textAlign="center">
        -
      </Text>
    );
  }

  const showDot = shouldShowFulfillmentSubtotalDiscrepancy(
    checkoutSub,
    groupSub
  );

  return (
    <ActivityDetailDiscrepancyDot
      show={showDot}
      label="Subtotal berbeda dari checkout"
    >
      <Text
        fontSize="sm"
        fontWeight="400"
        color="#373F41"
        textAlign="center"
        w="full"
      >
        {formatCurrency(groupSub)}
      </Text>
    </ActivityDetailDiscrepancyDot>
  );
}
